import { Link } from "@tanstack/react-router";
import { ChevronDown } from "lucide-react";
import { useState } from "react";
import { NAV, navLeafLinkProps, type NavItem } from "./nav-config";

/** Desktop (xl+) horizontal nav with hover/click flyout menus. */
export function DesktopNav({ items = NAV }: { items?: NavItem[] }) {
  const [openMenu, setOpenMenu] = useState<string | null>(null);

  return (
    <nav className="hidden xl:flex items-center gap-0.5" aria-label="Main">
      {items.map((n) =>
        n.kind === "link" ? (
          <Link
            key={n.label}
            to={n.to}
            className="px-2.5 py-2 text-sm text-muted-foreground hover:text-foreground transition"
            activeProps={{ className: "px-2.5 py-2 text-sm text-foreground" }}
            activeOptions={{ exact: n.to === "/" }}
          >
            {n.label}
          </Link>
        ) : (
          <div
            key={n.label}
            className="relative"
            onMouseEnter={() => setOpenMenu(n.label)}
            onMouseLeave={() =>
              setOpenMenu((m) => (m === n.label ? null : m))
            }
          >
            <button
              type="button"
              className="px-2.5 py-2 text-sm text-muted-foreground hover:text-foreground transition inline-flex items-center gap-1"
              aria-expanded={openMenu === n.label}
              aria-haspopup="true"
              onClick={() =>
                setOpenMenu((m) => (m === n.label ? null : n.label))
              }
            >
              {n.label}
              <ChevronDown size={14} className="opacity-70" />
            </button>
            {openMenu === n.label && (
              <div className="absolute left-0 top-full pt-2 min-w-[240px] z-50 animate-in fade-in-0 slide-in-from-top-1 zoom-in-95 duration-150 ease-out origin-top">
                <div className="rounded-2xl border border-border bg-popover p-2 shadow-[var(--shadow-elegant)] max-h-[70vh] overflow-y-auto">
                  {n.items.map((it) => (
                    <Link
                      key={`${it.to}-${it.hash ?? it.label}`}
                      {...navLeafLinkProps(it)}
                      onClick={() => setOpenMenu(null)}
                      className="block px-3 py-2 rounded-lg text-sm text-muted-foreground hover:text-foreground hover:bg-card transition"
                    >
                      {it.label}
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </div>
        ),
      )}
    </nav>
  );
}